import FlashIt from './containers/FlashIt.jsx';

export default FlashIt;
